<div class="tap-selection">
    <div class="question question-{{id}} {{class}}">
        <div class="question-text"><div class="text">{{{t text}}}</div></div>
        {{#if blocks}}<div data-region="question-blocks" class="question-blocks"></div>{{/if}}
        <div class="answers-container" data-answer-count="{{answers.length}}">
            {{#each answers}}
                <div class="question-answer">{{{t text}}}</div>
            {{/each}}
        </div>
    </div>
</div>

<div class=""answers-container" data-answer-count="7"></div>